<ng-container *ngIf="data[fieldName]">{{data[fieldName] | appUserTimezone:'MM/DD/YYYY hh:mm A'}}</ng-container>
